<template>
  <v-row no-gutters class="pr-0 align-center justify-space-between">
    <v-col cols="2">
      <v-container fluid class="d-none d-md-flex d-lg-flex" v-if="$store.getters.isLoggedIn">
        <v-img :src="logo"
                alt="logo"
                :max-width="($store.state.lookSoofia) ? 180 : 140"
              >
        </v-img>
      </v-container>
    </v-col>

    <v-col cols="10" class="d-flex align-center justify-end pr-0">
      <!-- <v-btn  large class="mr-1" icon dark :disabled="($route.name == 'Unauthorized' || $route.name == 'Authenticate')">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn  large class="mr-1" icon dark :disabled="($route.name == 'Unauthorized' || $route.name == 'Authenticate')">
        <v-icon>mdi-bell</v-icon>
      </v-btn> -->

      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="d-flex align-center">
            <v-avatar size="40" :color="($store.state.lookSoofia) ? 'black' : 'white'">
                <!-- <v-img :src="perfil"
                    alt="perfil"
                    v-if="$store.state.user.Usu_Imagen"
                ></v-img> -->
                <span :class="`font-weight-bold ${($store.state.lookSoofia) ? 'white' : 'purple'}--text`">
                  {{ $store.state.user.Usu_Nombre.charAt(0) }}{{ $store.state.user.Usu_Apellido.charAt(0) }}
                </span>
            </v-avatar>
            <span class="mx-2" style="font-size: .85rem;">{{ $store.state.user.name }}</span>
            <v-btn  small icon :disabled="($route.name == 'Unauthorized' || $route.name == 'Authenticate')">
              <v-icon class="title-menu">mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </template>

        <v-list dense>
          <v-list-item-group color="purple">
            <v-list-item link v-for="(item, i) in items" :key="i" :to="item.to" >
                <v-list-item-icon>
                    <v-icon>
                        {{item.icon}}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        <span>{{ item.title }}</span>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>


export default {
  props: ['drawer'],
  name: "HeaderApp",
  data() {
    return {
      items: [
        { title: "Cerrar Sesión", to: '/logout', icon: 'mdi-logout-variant' }
      ],
    };
  },
  computed:{
    perfil() {
      return process.env.VUE_APP_LOGIN_URI + this.$store.state.user.Usu_Imagen.slice(1, -1);
    },
    logo() {
      return require(`@/assets/${(this.$store.state.lookSoofia) ? 'soofia' : 'yo_white'}.png`)
    },
  },
  methods: {
  },
};
</script>

